import { render, staticRenderFns } from "./InputRichText.vue?vue&type=template&id=b8161082&scoped=true"
import script from "./InputRichText.vue?vue&type=script&lang=ts"
export * from "./InputRichText.vue?vue&type=script&lang=ts"
import style0 from "./InputRichText.vue?vue&type=style&index=0&id=b8161082&prod&lang=scss&scoped=true"
import style1 from "./InputRichText.vue?vue&type=style&index=1&id=b8161082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8161082",
  null
  
)

export default component.exports